import { Flex, Popover, Typography } from "antd"
import { SearchedConversation } from "../../../hooks/apis/conversations.api"
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../store/store";
import { formatMessageDate } from "../../../utils/messageDateFormat";
import Highlighter from "react-highlight-words";
import { setSelectedConversation } from "../../../store/slices/conversation.slice";
import { ellipsisString } from "../../../utils/ellipsisString";
import {
    getConversationParticipantSummary,
    participantLabel,
} from "../../../utils/conversationDisplay";
import { ConversationAvatar } from "./ConversationAvatar";



const ItemContentStyle: React.CSSProperties = {
    padding: "5px",
    borderRadius: "10px",
    cursor: "pointer",
};

const ConversationContentStyle: React.CSSProperties = { width: "50%" };

const conversationDateStyle: React.CSSProperties = {
    lineHeight: "20px",
    color: "rgb(119, 117, 135)",
    fontSize: "14px",
    minWidth: "85px",
}

const conversationMessageStyle: React.CSSProperties = {
    fontSize: "14px",
    fontWeight: "500",
    lineHeight: "20px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    color: "rgb(119, 117, 135)",
};
const ParticipantDetails = ({ labels }: { labels: string[] }) => (
    <Flex vertical gap={4} style={{ minWidth: "220px" }}>
        {labels.map((label) => (
            <Typography.Text key={label} style={{ fontSize: "12px" }}>
                {label}
            </Typography.Text>
        ))}
    </Flex>
);

export const SearchConversationCard = ({
    conversation,
    searchInput,
    searchType,
    setIsModal,
    setIsNewConversation,
}: {
    conversation: SearchedConversation
    searchInput: string
    searchType: string
    setIsModal: Function
    setIsNewConversation: Function
}) => {
    const dispatch: AppDispatch = useDispatch()

    const { data: contacts } = useSelector((state: RootState) => state.contacts);

    const participantSummary = getConversationParticipantSummary(
        conversation.participants,
        contacts
    );
    const participantLabels = conversation.participants.map((participant) =>
        participantLabel(participant, contacts)
    );

    const handleClick = () => {
        dispatch(setSelectedConversation({
            conversation_id: conversation.conversation_id,
            did: conversation.did,
            participants: conversation.participants,
            type: conversation.type,
            position: Number(conversation.position),
            unread_messages_count: conversation.unread_messages_count,
            search: searchInput,
            searched_message_id: conversation.send_id || conversation.id
        }))
        setIsNewConversation(false)
        setIsModal(false)
    }

   
    return <Flex
        onClick={() => {
            handleClick()
        }}
        align="flex-start"
        justify="space-evenly"
        style={{
            ...ItemContentStyle,
        }}
        wrap="wrap"
        gap="small"
    >
        <ConversationAvatar participants={conversation.participants} />
        <Flex gap={"small"} style={ConversationContentStyle} vertical={true}>
            <Flex gap={8} style={{ minWidth: 0 }}>
                {
                    searchType === "contact" ?
                        <Highlighter
                            searchWords={[searchInput]}
                            autoEscape={true}
                            textToHighlight={participantSummary.names}
                        /> : <Typography.Text style={{ ...conversationMessageStyle, flex: "1 1 0", minWidth: 0 }}>
                            {participantSummary.names}
                        </Typography.Text>
                }
                {participantSummary.additionalParticipantCount > 0 && (
                    <Popover
                        content={<ParticipantDetails labels={participantLabels.slice(2)} />}
                        trigger="hover"
                    >
                        <Typography.Text style={{ cursor: "help", flex: "0 0 auto", fontSize: "14px", fontWeight: 500 }}>
                            +{participantSummary.additionalParticipantCount}
                        </Typography.Text>
                    </Popover>
                )}
            </Flex>

            {
                searchType === "conversation" && <Highlighter
                    searchWords={[searchInput]}
                    autoEscape={true}
                    textToHighlight={ellipsisString(conversation.body, searchInput, 10)}
                />
            }

        </Flex>
        <Flex align="center" vertical={true}>
            <Typography.Text style={conversationDateStyle}>{formatMessageDate(new Date(conversation.last_message_time || conversation.timestamp || 0))}</Typography.Text>
        </Flex>
    </Flex>
}